import React from 'react';
import { Link } from 'react-router-dom';
import { BravosWordmark } from '../../components/BravosWordmark';

export const AUTH_PAGE_BG = 'var(--bg-page)';

export function AuthChrome({
  children,
  wide,
}: {
  children: React.ReactNode;
  wide?: boolean;
}) {
  return (
    <div
      className="relative min-h-screen font-bravos antialiased text-theme-text"
      style={{ backgroundColor: AUTH_PAGE_BG }}
    >
      <div className="relative z-10 flex min-h-screen flex-col">
        <header
          className="relative z-50 w-full shrink-0"
          style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top))' }}
        >
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 sm:py-4">
            <Link to="/" className="shrink-0" aria-label="Bravos home">
              <BravosWordmark className="h-9 w-auto sm:h-11" />
            </Link>
          </div>
        </header>

        <main className="flex flex-1 flex-col px-6 pb-10 pt-4 sm:px-10 lg:px-12">
          <div className={`mx-auto w-full ${wide ? 'max-w-[640px]' : 'max-w-[420px]'}`}>
            {children}
          </div>
        </main>

        <footer
          className="relative z-40 shrink-0"
          style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
        >
          <div className="mx-auto flex max-w-7xl items-end justify-between gap-4 px-4 pb-3 pt-2 sm:px-6 sm:pb-4 sm:pt-2">
            <nav
              className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-1 text-left text-xs font-normal text-theme-text sm:gap-x-5 sm:text-sm"
              aria-label="Legal"
            >
              <Link to="/terms" className="transition hover:opacity-80">
                T&amp;Cs
              </Link>
              <Link to="/privacy" className="transition hover:opacity-80">
                Privacy Policy
              </Link>
            </nav>
            <p className="pointer-events-none shrink-0 text-right text-xs font-normal text-theme-text sm:text-sm">
              © 2026 Bravos
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export const authTitleClass =
  'font-pageTitle text-[28px] font-bold leading-[1.12] tracking-[-0.02em] text-[var(--ink)] sm:text-[32px] sm:tracking-[-0.02em]';
export const authSubtitleClass = 'mt-2 text-sm leading-relaxed text-[var(--text-secondary)] sm:text-[15px]';
export const authLabelClass = 'mb-1.5 block text-[13px] font-medium text-[var(--text-secondary)]';
export const authPrimaryBtnClass =
  'flex h-[52px] w-full items-center justify-center gap-2 rounded-xl bg-[var(--action-primary)] text-base font-semibold text-[var(--ink)] transition-colors hover:bg-[var(--action-primary-pressed)] active:bg-[var(--success)] disabled:cursor-not-allowed disabled:bg-[var(--success-tint)] disabled:text-ink/40 disabled:hover:bg-[var(--success-tint)]';
export const authQuietBtnClass =
  'flex h-[52px] w-full items-center justify-center gap-2 rounded-xl bg-subtle text-base font-semibold text-[var(--ink)]';
export const authLinkClass = 'font-semibold text-[var(--ink)] underline underline-offset-[3px]';
export const authQuietLinkClass = 'text-[var(--text-secondary)] underline underline-offset-[3px]';

export function authInputClass(error?: boolean): string {
  const border = error
    ? 'border-[var(--error)] bg-card'
    : 'border-line bg-card focus:border-[var(--ink)]';
  return `block h-[52px] w-full rounded-xl border-[1.5px] px-3.5 text-base text-[var(--ink)] outline-none transition-colors placeholder:text-[var(--text-secondary)] ${border}`;
}
